import { Component} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthenticationService } from "./_services/authentication.service";
import { Location } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  userRole: any;
  selectedService: any;
  userFullName: any;
  title = 'central-credit-app';
  loading:any;
  activeMenu: any;


  constructor(private router: Router, private route: ActivatedRoute, private location: Location,
    private authService: AuthenticationService) {
    this.checkAuthState();
    console.log('✅ router.url', router, '✅');
    this.route.params.subscribe(params => {
      console.log(this.location.path());
      console.log('🔥📣 params', params, '🔥📣');
        const productId = params['id'];
        // Use productId to fetch data or perform actions
      });
  }

  ngAfterContentInit(){
    
  }

  logout(){
    this.authService.logout();
    this.userRole = null;
    this.selectedService = "";
  }

  checkAuthState(){
    
    this.authService.checkToken();
    
    this.authService.authenticationState.subscribe(
      (state) => {
        
        if(state){
          this.userFullName = this.authService.getUserFullName();
          this.userRole = 'producer';
          console.log('userFullName', this.userFullName);
          console.log('here');
          this.setMenu();

          if(this.router.url.length < 1 || this.router.url == "/login"){
            if(this.selectedService == 'insurance'){
              this.router.navigateByUrl('/dashboard');
            } else if(this.selectedService == 'loans'){
              this.router.navigateByUrl('/loans/dashboard');
            }
            
          }
          
          
        }
      });
  }

  setMenu(){
    // if(this.selectedService == 'insurance'){
      this.activeMenu = this.allMenu['insurance'];
    // }else if(this.selectedService == 'loans'){
    //   this.activeMenu = this.allMenu['loans'];
    // }
    if(this.userRole == 'producer'){
      this.activeMenu = this.activeMenu.filter((x:any) => x.role == 'producer' );
    }
  }

  updatesSelectedService(selectedService:any){
    this.authService.updateSelectedService(selectedService);
    if(selectedService == 'insurance'){
      this.router.navigateByUrl('/');
    }
    if(selectedService == 'loans'){
      this.router.navigateByUrl('/loans');
      
    }
    this.selectedService = selectedService;
    this.setMenu();
  }

    allMenu = {
    insurance: [
      {page: "Dashboard",
      routerLink:"/dashboard",
      icon: "dashboard.svg",
      role: "producer"},
      {page: "Cotización",
      routerLink:"/quotation",
      icon: "money-check-alt.svg",
      role: "producer"},
      {page: "Contratos",
      routerLink:"/contracts",
      icon: "file-contract.svg",
      role: "producer"},
      {page: "Pagos",
      routerLink:"/payments",
      icon: "checklist.svg",
      role: "admin"},
      {page: "Usuarios",
      routerLink:"/users",
      icon: "users.svg",
      role: "admin"},
      {page: "Agencias",
      routerLink:"/agencias",
      icon: "building.svg",
      role: "admin"},
    ],
    loans:[
      {page: "Dashboard",
      routerLink:"loans/dashboard",
      icon: "dashboard.svg",
      role: "producer"},
      {page: "Cotización",
      routerLink:"loans/quotation",
      icon: "money-check-alt.svg",
      role: "producer"},
      {page: "Contratos",
      routerLink:"loans/contracts",
      icon: "file-contract.svg",
      role: "producer"},
      {page: "Pagos",
      routerLink:"loans/payments",
      icon: "checklist.svg",
      role: "admin"},
      {page: "Usuarios",
      routerLink:"/users",
      icon: "users.svg",
      role: "admin"},
      {page: "Compañias",
      routerLink:"/companies",
      icon: "building.svg",
      role: "admin"},
    ]
  }

}
